import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import DatePickerField from "../../component/InputFieldLayout/datePicker";
import { getRecipientMinistryStateAction } from "../../actions/mis.action";
import { PROJECT_CLASSIFICATION } from "../../constant";
import {
  fetchFlatFileReport,
  fetchIssueSubCategories
} from "../../actions/mis.action";
import { parseInt, uniqBy } from "lodash";
import { setLocalstorage, getLocalstorage } from "../../helper";
import Select from "react-select";
import { components } from "react-select";
import NumberField from "../../component/InputFieldLayout/numberField";
import { replaceCharacterWith } from "../../../src/helper";

class IssueSummarySearchModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this._getInitForm(),
      openModal: true,
      sponsoringMinistryList: [],
      inceptionDate: false,
      issueInceptionDate: false,
      filtersList: [],
      appliedFilter: getLocalstorage("filters") || [],
      previousFilterCount: 0,
      currentFilterCount: 0
    };
  }

  implementationModeTransformer = {
    PPP: "Private Public Partnership",
    PRIVATE: "Private",
    PUBLIC: "Public",
    NA: "NA"
  };

  _getInitForm = () => {
    return {
      projectCreatedFrom: "",
      projectCreatedTo: "",
      sponsoringMinistry: "",
      projectClassification: "",
      projectSector: "",
      implementationMode: "",
      projectLocation: "",
      projectScheme: "",
      projectStatus: "",
      projectCostTo: "",
      projectCostFrom: "",
      issueCreatedFrom: "",
      issueCreatedTo: "",
      issueSponsoringMinistry: [],
      issueDistrict: [],
      issueCategory: [],
      issueSubCategory: [],
      issueStatus: []
    };
  };

  componentDidMount() {
    const { getRecipientMinistryStateAction, onOpenOfModal } = this.props;
    const { openModal } = this.state;
    getRecipientMinistryStateAction().then(resp => {
      if (resp) {
        this.setState({
          sponsoringMinistryList: resp.data
        });
      }
    });
    const filter = getLocalstorage("filters");
    if (filter && filter !== null) {
      this.setState({ previousFilterCount: filter.length });
      this.onOpeingOfModalAgain();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.issueCategory !== this.state.issueCategory) {
      if (this.state.issueCategory.length !== 0) {
        this.props.fetchIssueSubCategories(
          parseFloat(
            this.state.issueCategory[this.state.issueCategory.length - 1].value
          )
        );
      }
    }
  }

  onOpeingOfModalAgain = () => {
    const filter = getLocalstorage("filters");
    if (filter && filter !== null) {
      const filters = getLocalstorage("filters");
      const filterMap = {
        "Created Date": "projectDateFilter",
        "Issue Created Date": "issueDateFilter",
        sponsoringMinistry: "sponsoringMinistry",
        projectClassification: "projectClassification",
        sector: "projectSector",
        implementationMode: "implementationMode",
        location: "projectLocation",
        projectScheme: "projectScheme",
        projectStatus: "projectStatus",
        recipientGroup: "issueSponsoringMinistry",
        districtDepartments: "issueDistrict",
        issueCategory: "issueCategory",
        issueSubCategory: "issueSubCategory",
        issueStatus: "issueStatus",
        projectCost: "projectCostFilter"
      };

      const filterObject = filters.reduce((result, filter) => {
        const filterKey =
          filterMap[filter.optionName] || filterMap[filter.type];
        if (filterKey) {
          result[filterKey] = result[filterKey] || [];
          result[filterKey].push(filter);
        }
        return result;
      }, {});

      const {
        projectDateFilter,
        issueDateFilter,
        sponsoringMinistry,
        projectClassification,
        projectSector,
        implementationMode,
        projectLocation,
        projectScheme,
        projectStatus,
        issueSponsoringMinistry,
        issueDistrict,
        issueCategory,
        issueSubCategory,
        issueStatus,
        projectCostFilter
      } = filterObject;

      const projectCreatedDate =
        projectDateFilter &&
        projectDateFilter.length !== 0 &&
        projectDateFilter[0].projectCreatedFrom;
      const projectCreatedDateTo =
        projectDateFilter &&
        projectDateFilter.length !== 0 &&
        projectDateFilter[0].projectCreatedTo;

      const issueCreatedDate =
        issueDateFilter &&
        issueDateFilter.length !== 0 &&
        issueDateFilter[0].issueCreatedFrom;

      const issueCreatedTo =
        issueDateFilter &&
        issueDateFilter.length !== 0 &&
        issueDateFilter[0].issueCreatedTo;

      this.setState({
        projectCreatedFrom: projectCreatedDate && new Date(projectCreatedDate),
        projectCreatedTo:
          projectCreatedDateTo && new Date(projectCreatedDateTo),
        issueCreatedFrom: issueCreatedDate && new Date(issueCreatedDate),
        issueCreatedTo: issueCreatedTo && new Date(issueCreatedTo),
        projectCostFrom:
          projectCostFilter &&
          projectCostFilter.length !== 0 &&
          projectCostFilter[0].projectCostFrom,
        projectCostTo:
          projectCostFilter &&
          projectCostFilter.length !== 0 &&
          projectCostFilter[0].projectCostTo,
        sponsoringMinistry:
          sponsoringMinistry && sponsoringMinistry.map(item => item),
        projectClassification:
          projectClassification && projectClassification.map(item => item),
        projectSector: projectSector && projectSector.map(item => item),
        implementationMode:
          implementationMode && implementationMode.map(item => item),
        projectLocation: projectLocation && projectLocation.map(item => item),
        projectScheme: projectScheme && projectScheme.map(item => item),
        projectStatus: projectStatus && projectStatus.map(item => item),
        issueSponsoringMinistry:
          issueSponsoringMinistry && issueSponsoringMinistry.map(item => item),
        issueDistrict: issueDistrict && issueDistrict.map(item => item),
        issueCategory: issueCategory && issueCategory.map(item => item),
        issueSubCategory:
          issueSubCategory && issueSubCategory.map(item => item),
        issueStatus: issueStatus && issueStatus.map(item => item)
      });
    }
  };

  onProjectCraeatedDateChange = value => {
    value === null
      ? this.setState({ projectCreatedFrom: "" })
      : this.setState({ projectCreatedFrom: new Date(value) });
  };

  onProjectCraeatedFromDateChange = value => {
    value === null
      ? this.setState({ projectCreatedTo: "" })
      : this.setState({ projectCreatedTo: new Date(value) });
  };
  onIssueCraeatedDateToChange = value => {
    value === null
      ? this.setState({ issueCreatedTo: "" })
      : this.setState({ issueCreatedTo: new Date(value) });
  };
  onIssueCraeatedFromDateChange = value => {
    value === null
      ? this.setState({ issueCreatedFrom: "" })
      : this.setState({ issueCreatedFrom: new Date(value) });
  };

  onInputChange = (event, name) => {
    this.setState({ [name]: event });
  };

  validateFiltersOfProjectDates = () => {
    let { projectCreatedFrom, projectCreatedTo, filtersList } = this.state;
    let date = { type: "createdDate" };
    let filter = null;
    let createdDate = { from: projectCreatedFrom, to: projectCreatedTo };
    if (projectCreatedFrom && projectCreatedTo) {
      filtersList.unshift({
        id: "createdDate",
        label: `From: ${createdDate.from.getDate()}/${createdDate.from.getMonth() +
          1}/${createdDate.from.getFullYear()} - To: ${createdDate.to.getDate()}/${createdDate.to.getMonth() +
          1}/${createdDate.to.getFullYear()}`,
        type: "Created Date",
        projectCreatedFrom: new Date(this.state.projectCreatedFrom).getTime(),
        projectCreatedTo: new Date(this.state.projectCreatedTo).getTime(),
        optionName: "createdDate",
        value: {
          from: new Date(projectCreatedFrom).getTime(),
          to: new Date(projectCreatedTo).getTime()
        }
      });
      date.createdDate = createdDate;
    }
    let temp = uniqBy(filtersList, "id");
    this.setState({
      filtersList: temp
    });
  };

  validateFiltersOfIssueDates = () => {
    let { issueCreatedFrom, issueCreatedTo, filtersList } = this.state;
    let date = { type: "createdDate" };
    let filter = null;
    let createdDate = { from: issueCreatedFrom, to: issueCreatedTo };
    if (issueCreatedFrom && issueCreatedTo) {
      filtersList.unshift({
        id: "createdDate",
        label: `From: ${createdDate.from.getDate()}/${createdDate.from.getMonth() +
          1}/${createdDate.from.getFullYear()} - To: ${createdDate.to.getDate()}/${createdDate.to.getMonth() +
          1}/${createdDate.to.getFullYear()}`,
        type: "Issue Created Date",
        issueCreatedFrom: new Date(issueCreatedFrom).getTime(),
        issueCreatedTo: new Date(issueCreatedTo).getTime(),
        optionName: "issueCreatedDate",
        value: {
          from: new Date(issueCreatedFrom).getTime(),
          to: new Date(issueCreatedTo).getTime()
        }
      });
      date.createdDate = createdDate;
    }
    let temp = uniqBy(filtersList, "id");
    this.setState({
      filtersList: temp
    });
  };

  validateFiltersOfCost = () => {
    let { projectCostTo, projectCostFrom, filtersList } = this.state;
    let filter = null;
    let projectCost = { from: projectCostTo, to: projectCostFrom };
    if (projectCostFrom && projectCostTo) {
      filtersList.unshift({
        id: "projectCost",
        label: `From: ${projectCost.from} - To: ${projectCost.to}`,
        type: "Project Cost",
        projectCostFrom: projectCostFrom,
        projectCostTo: projectCostTo,
        value: {
          from: projectCostTo,
          to: projectCostFrom
        },
        optionName: "projectCost"
      });
    }
    let temp = uniqBy(filtersList, "id");
    this.setState({
      filtersList: temp
    });
  };

  onInceptionDateChecked = () => {
    const { inceptionDate } = this.state;
    if (inceptionDate) {
      this.setState(
        {
          projectCreatedFrom: new Date(2013, 0, 1, 0, 0, 0, 0)
        },
        this.validateFiltersOfDates
      );
    } else {
      this.setState({
        projectCreatedFrom: ""
      });
    }
  };

  onIssueInceptionDateChecked = () => {
    const { issueInceptionDate } = this.state;
    if (issueInceptionDate) {
      this.setState(
        {
          issueCreatedFrom: new Date(2013, 0, 1, 0, 0, 0, 0)
        },
        this.validateFiltersOfDates
      );
    } else {
      this.setState({
        issueCreatedFrom: ""
      });
    }
  };

  onClickOfCloseButton = () => {
    const { onOpenOfModal } = this.props;
    const { openModal } = this.state;
    this.setState({
      openModal: !openModal
    });
    onOpenOfModal(openModal);
  };

  clearAllFilledDataInformation = () => {
    const { inceptionDate } = this.state;
    this.setState({
      projectCreatedFrom: "",
      projectCreatedTo: "",
      sponsoringMinistry: "",
      projectClassification: "",
      projectSector: "",
      implementationMode: "",
      projectLocation: "",
      projectScheme: "",
      projectStatus: "",
      projectCostTo: "",
      projectCostFrom: "",
      issueCreatedFrom: "",
      issueCreatedTo: "",
      issueSponsoringMinistry: [],
      issueDistrict: [],
      issueCategory: [],
      issueSubCategory: [],
      issueStatus: [],
      inceptionDate: false,
      issueInceptionDate: false
    });
  };

  onSelectChange = (value, name) => {
    const update = {};
    update[name] = value;
    this.setState(update);
  };

  onClickingSectorsDropDown() {
    const { sectorsList } = this.props;
    const sectorsListOption = [];
    sectorsList &&
      sectorsList.data &&
      sectorsList.data.map(sectorsList => {
        sectorsListOption.push({
          name: "projectSector",
          label: sectorsList.name,
          value: sectorsList.id,
          optionName: "sector"
        });
      });
    return sectorsListOption;
  }

  onClickingLocationDropDown() {
    const { statesListData } = this.props;
    const statesListOption = [];
    statesListData &&
      statesListData.data &&
      statesListData.data.map(statesListData => {
        statesListOption.push({
          name: "projectLocation",
          label: statesListData.name,
          value: statesListData.id,
          optionName: "location"
        });
      });
    return statesListOption;
  }

  onClickingSchemeDropDown() {
    const { schemesList } = this.props;
    const schemesListOption = [];
    schemesList &&
      schemesList.data &&
      schemesList.data.map(schemesList => {
        schemesListOption.push({
          name: "projectScheme",
          label: schemesList.name,
          value: schemesList.id,
          optionName: "projectScheme"
        });
      });
    return schemesListOption;
  }

  onClickingStatusDropDown() {
    const { projectStatusList } = this.props;
    const statusListOption = [];
    projectStatusList &&
      projectStatusList.data &&
      projectStatusList.data.statuses.map(statusList => {
        statusListOption.push({
          name: "projectStatus",
          label: replaceCharacterWith(statusList, "_", " ") || statusList,
          value: statusList,
          optionName: "projectStatus"
        });
      });
    return statusListOption;
  }
  onClickingIssueSponsoringDropDown() {
    const { misSponoringMinistry } = this.props;
    const issueSponsoringOption = [];
    misSponoringMinistry.map(issueSponsoring => {
      issueSponsoringOption.push({
        name: "issueSponsoringMinistry",
        label: issueSponsoring.name,
        value: issueSponsoring.id,
        optionName: "recipientGroup"
      });
    });
    return issueSponsoringOption;
  }
  onClickingDistrictDropDown() {
    const { ddByParentIdsList } = this.props;
    const districtOption = [];
    ddByParentIdsList &&
      ddByParentIdsList.map(district => {
        districtOption.push({
          name: "issueDistrict",
          label: district.name,
          value: district.id,
          optionName: "districtDepartments"
        });
      });
    return districtOption;
  }
  onClickingIssueCategoryDropDown() {
    const { issueCategoriesList } = this.props;
    const issueCategoryOption = [];
    issueCategoriesList &&
      issueCategoriesList.data &&
      issueCategoriesList.data.map(issueCategory => {
        issueCategoryOption.push({
          name: "issueCategory",
          label: issueCategory.name,
          value: issueCategory.id,
          optionName: "issueCategory"
        });
      });
    return issueCategoryOption;
  }
  onClickingIssueSubCategoryDropDown() {
    const { issueSubCategoriesList, issueCategoriesList } = this.props;
    const issueSubCategoryOption = [];
    if (issueSubCategoriesList.length !== 0) {
      issueCategoriesList &&
        issueCategoriesList.data &&
        issueSubCategoriesList.length !== 0 &&
        issueSubCategoriesList.data.map(issueSubCategory => {
          issueSubCategoryOption.push({
            name: "issueSubCategory",
            label: issueSubCategory.name,
            value: issueSubCategory.id,
            optionName: "issueSubCategory"
          });
        });
      return issueSubCategoryOption;
    }
  }
  onClickingImplementationModeDropDown() {
    const { implementationModesList } = this.props;
    const implementationModeListOption = [];
    implementationModesList &&
      implementationModesList.data &&
      implementationModesList.data.implementationModeList.map(
        implementationModesList => {
          implementationModeListOption.push({
            name: "implementationMode",
            label: this.implementationModeTransformer[implementationModesList],
            value: implementationModesList,
            optionName: "implementationMode"
          });
        }
      );
    return implementationModeListOption;
  }
  onClickingIssueStatusDropDown() {
    const { workflowStateDataForCentral } = this.props;
    const issueStatusOption = [];
    workflowStateDataForCentral &&
      workflowStateDataForCentral.map(issueStatus => {
        issueStatusOption.push({
          name: "issueStatus",
          label: issueStatus.name,
          value: issueStatus.workflowStateCategory,
          optionName: "issueStatus"
        });
      });
    return issueStatusOption;
  }

  onClickofApplyAllButton = () => {
    const { onOpenOfModal } = this.props;
    const {
      sponsoringMinistry,
      projectClassification,
      projectSector,
      implementationMode,
      projectLocation,
      projectScheme,
      projectStatus,
      projectCostFrom,
      projectCostTo,
      projectCreatedFrom,
      projectCreatedTo,
      issueCreatedFrom,
      issueCreatedTo,
      issueSponsoringMinistry,
      issueCategory,
      issueSubCategory,
      issueDistrict,
      issueStatus,
      openModal,
      filtersList,
      previousFilterCount,
      currentFilterCount
    } = this.state;

    function filterNullUndefined(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0)
        )
      );
    }

    const createFilterArray = (sourceArray, targetType) => {
      return sourceArray ? sourceArray.map(item => parseInt(item.value)) : [];
    };

    let sponsoringMinistryFilter = createFilterArray(sponsoringMinistry);
    let projectClassificationFilter = projectClassification
      ? projectClassification.map(item => item.value)
      : [];
    let sectorsListFilter = createFilterArray(projectSector, "parseInt");
    let implementationModeFilter = implementationMode
      ? implementationMode.map(item => item.value)
      : [];
    let locationFilter = createFilterArray(projectLocation, "parseInt");
    let schemeFilter = createFilterArray(projectScheme, "parseInt");
    let statusFilter = projectStatus
      ? projectStatus.map(item => item.value)
      : [];

    let issueSponsoringFilter = createFilterArray(
      issueSponsoringMinistry,
      "parseInt"
    );
    let issueDistrictFilter = createFilterArray(issueDistrict, "parseInt");
    let issueCategoryFilter = createFilterArray(issueCategory, "parseInt");
    let issueSubCategoryFilter = createFilterArray(
      issueSubCategory,
      "parseInt"
    );
    let issueStatusFilter = issueStatus
      ? issueStatus.map(item => item.value)
      : [];

    var appliedFilters = filterNullUndefined({
      sponsoringMinistry: sponsoringMinistry ? sponsoringMinistryFilter : null,
      projectClassification: projectClassification
        ? projectClassificationFilter
        : null,
      sector: projectSector ? sectorsListFilter : null,
      implementationMode: implementationMode ? implementationModeFilter : null,
      location: projectLocation ? locationFilter : null,
      projectScheme: projectScheme ? schemeFilter : null,
      projectStatus: projectStatus ? statusFilter : null,
      projectCost:
        projectCostFrom && projectCostTo
          ? [{ from: projectCostTo, to: projectCostFrom }]
          : null,
      createdDate:
        projectCreatedFrom && projectCreatedTo
          ? {
              from: new Date(projectCreatedFrom).getTime(),
              to: new Date(projectCreatedTo).getTime()
            }
          : null,
      issueCreatedDate:
        issueCreatedFrom && issueCreatedTo
          ? {
              from: new Date(issueCreatedFrom).getTime(),
              to: new Date(issueCreatedTo).getTime()
            }
          : null,
      recipientGroup: issueSponsoringMinistry ? issueSponsoringFilter : null,
      districtDepartments: issueDistrict ? issueDistrictFilter : null,
      issueCategory: issueCategory ? issueCategoryFilter : null,
      issueSubCategory: issueSubCategory ? issueSubCategoryFilter : null,
      issueStatus: issueStatus ? issueStatusFilter : null
    });
    this.props.fetchFlatFileReport(appliedFilters);

    this.validateFiltersOfProjectDates();
    this.validateFiltersOfCost();
    this.validateFiltersOfIssueDates();
    const appliedFilterList = this.onApplyingFilters();
    const newList = [...appliedFilterList, ...this.state.filtersList];
    const uniqueNewList = Array.from(new Set(newList.map(JSON.stringify))).map(
      JSON.parse
    );
    const filters = setLocalstorage("filters", uniqueNewList);
    this.setState({ currentFilterCount: uniqueNewList.length });
    this.setState({ openModal: !openModal });
    onOpenOfModal(
      openModal,
      this.state.previousFilterCount,
      uniqueNewList.length
    );
  };

  onApplyingFilters = () => {
    const {
      sponsoringMinistry,
      projectClassification,
      projectScheme,
      projectSector,
      projectStatus,
      implementationMode,
      issueSponsoringMinistry,
      issueCategory,
      issueSubCategory,
      issueStatus,
      issueDistrict,
      projectLocation
    } = this.state;
    let results = [];
    let filters = [];
    sponsoringMinistry && filters.push(...sponsoringMinistry);
    projectClassification && filters.push(...projectClassification);
    projectScheme && filters.push(...projectScheme);
    projectStatus && filters.push(...projectStatus);
    projectSector && filters.push(...projectSector);
    implementationMode && filters.push(...implementationMode);
    issueSponsoringMinistry && filters.push(...issueSponsoringMinistry);
    issueCategory && filters.push(...issueCategory);
    issueSubCategory && filters.push(...issueSubCategory);
    issueStatus && filters.push(...issueStatus);
    issueDistrict && filters.push(...issueDistrict);
    projectLocation && filters.push(...projectLocation);
    const uniqueFilters = Array.from(new Set(filters));
    return uniqueFilters;
  };

  render() {
    const {
      projectCreatedFrom,
      projectCreatedTo,
      sponsoringMinistryList,
      sponsoringMinistry,
      projectClassification,
      projectSector,
      implementationMode,
      projectLocation,
      projectScheme,
      projectStatus,
      projectCostTo,
      projectCostFrom,
      issueCreatedFrom,
      issueCreatedTo,
      issueSponsoringMinistry,
      issueDistrict,
      issueCategory,
      issueSubCategory,
      issueStatus,
      openModal,
      inceptionDate,
      filtersList,
      issueInceptionDate
    } = this.state;
    const {
      onProjectCraeatedDateChange,
      onProjectCraeatedFromDateChange,
      onIssueCraeatedDateToChange,
      onIssueCraeatedFromDateChange,
      onClickOfCloseButton,
      clearAllFilledDataInformation,
      onClickofApplyAllButton,
      onInputChange,
      onInceptionDateChecked,
      onIssueInceptionDateChecked
    } = this;
    const sponsoringMinistryOptions = [];
    sponsoringMinistryList.map(sponsoringMinistry => {
      sponsoringMinistryOptions.push({
        name: "sponsoringMinistry",
        label: sponsoringMinistry.name,
        value: sponsoringMinistry.id,
        optionName: "sponsoringMinistry"
      });
    });
    const Option = props => {
      return (
        <div>
          <components.Option {...props}>
            <div class="checkbox-container-options">
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />{" "}
              <label>{props.label}</label>
            </div>
          </components.Option>
        </div>
      );
    };

    const selectStyle = {
      control: (baseStyles, state) => ({
        ...baseStyles,
        color: "#000000",
        fontFamily: "mpsb",
        fontSize: "16px",
        lineHeight: "22px"
      }),
      option: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: "white",
        fontSize: "14px",
        lineHeight: "18px",
        color: "#525252"
      })
    };

    return (
      <Modal
        show={openModal}
        onHide={onClickOfCloseButton}
        className="issue-summary-modal issue-summary-search-modal"
        centered={true}
        dialogClassName="box-shadow-none"
      >
        <Modal.Body>
          <div className="issue-summary-modal-body">
            <h3 className="heading-issue-summary mb-2">Project</h3>
            <div className="input-fields d-flex align-items-start inception-date-inputfield">
              <div
                className={`input-field-left ${
                  inceptionDate ? "date-field-disable" : ""
                }`}
              >
                <DatePickerField
                  label={"Created From"}
                  formData={projectCreatedFrom}
                  className="meeting-date"
                  onChange={onProjectCraeatedDateChange}
                  isInceptionDate={inceptionDate}
                />
                <Form.Group
                  className="checkbox inception-date"
                  controlId="formBasicCheckbox"
                >
                  <Form.Check
                    className="d-flex align-items-center inception-checkbox"
                    type="checkbox"
                    label="Inception Date"
                    onClick={() => {
                      this.setState(
                        { inceptionDate: !inceptionDate },
                        onInceptionDateChecked
                      );
                    }}
                    checked={inceptionDate}
                  />
                </Form.Group>
              </div>
              <div className="input-field-right">
                <DatePickerField
                  label={"Created To"}
                  className="meeting-date"
                  formData={projectCreatedTo}
                  onChange={onProjectCraeatedFromDateChange}
                />
              </div>
            </div>
            <div className="input-fields d-flex mt-3">
              <div className="input-field-left select-field">
                <Select
                  placeholder="-Select Sponsoring Ministry-"
                  options={sponsoringMinistryOptions}
                  value={sponsoringMinistry}
                  onChange={event =>
                    this.onSelectChange(event, "sponsoringMinistry")
                  }
                  isMulti={true}
                  styles={selectStyle}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  classNamePrefix="react-select"
                />
              </div>
              <div className="input-field-right select-field">
                <Select
                  placeholder="-Select Project Classification-"
                  options={PROJECT_CLASSIFICATION}
                  value={projectClassification}
                  onChange={event =>
                    this.onSelectChange(event, "projectClassification")
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            <div className="input-fields d-flex mt-4">
              <div className="input-field-left select-field">
                <Select
                  placeholder="-Select Sectors-"
                  options={this.onClickingSectorsDropDown()}
                  value={projectSector}
                  onChange={event =>
                    this.onSelectChange(event, "projectSector")
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                />
              </div>
              <div className="input-field-right select-field">
                <Select
                  placeholder="-Select Implementation Mode-"
                  options={this.onClickingImplementationModeDropDown()}
                  value={implementationMode}
                  onChange={event =>
                    this.onSelectChange(event, "implementationMode")
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            <div className="input-fields d-flex mt-4">
              <div className="input-field-left select-field">
                <Select
                  placeholder="-Select Location-"
                  options={this.onClickingLocationDropDown()}
                  value={projectLocation}
                  onChange={event =>
                    this.onSelectChange(event, "projectLocation")
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                />
              </div>
              <div className="input-field-right select-field">
                <Select
                  placeholder="-Select Scheme-"
                  options={this.onClickingSchemeDropDown()}
                  value={projectScheme}
                  onChange={event =>
                    this.onSelectChange(event, "projectScheme")
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            <div className="input-fields d-flex mt-4">
              <div className="input-field-left select-field">
                <Select
                  placeholder="-Select Project Status-"
                  options={this.onClickingStatusDropDown()}
                  value={projectStatus}
                  onChange={event =>
                    this.onSelectChange(event, "projectStatus")
                  }
                  isMulti={true}
                  isClearable={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            <div className="input-fields d-flex mt-2">
              <div className="input-field-left">
                <NumberField
                  name="projectCostTo"
                  label={"Cost From"}
                  placeholder={"₹0"}
                  formData={projectCostTo}
                  onChange={onInputChange}
                  style={{ fontSize: "14px", lineHeight: "22px" }}
                />
              </div>
              <div className="input-field-right">
                <NumberField
                  name="projectCostFrom"
                  label={"Cost To"}
                  placeholder={"₹0"}
                  formData={projectCostFrom}
                  onChange={onInputChange}
                  style={{ fontSize: "14px", lineHeight: "22px" }}
                />
              </div>
            </div>
            <div>
              <h3 className="heading-issue-summary mb-2">Issues</h3>
              <div className="input-fields d-flex align-items-start inception-date-inputfield">
                <div
                  className={`input-field-left ${
                    issueInceptionDate ? "date-field-disable" : ""
                  }`}
                >
                  <DatePickerField
                    label={"Created From"}
                    formData={issueCreatedFrom}
                    onChange={onIssueCraeatedFromDateChange}
                    issueInceptionDate={issueInceptionDate}
                    className="issue-created-from meeting-date"
                  />
                  <Form.Group
                    className="checkbox inception-date"
                    controlId="formBasicCheckbox"
                  >
                    <Form.Check
                      className="d-flex align-items-center inception-checkbox"
                      type="checkbox"
                      label="Inception Date"
                      onClick={() => {
                        this.setState(
                          { issueInceptionDate: !issueInceptionDate },
                          onIssueInceptionDateChecked
                        );
                      }}
                      checked={issueInceptionDate}
                    />
                  </Form.Group>
                </div>
                <div className="input-field-right">
                  <DatePickerField
                    label={"Created To"}
                    formData={issueCreatedTo}
                    onChange={onIssueCraeatedDateToChange}
                    className="meeting-date"
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-3">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Recipient Ministry-"
                    options={this.onClickingIssueSponsoringDropDown()}
                    value={issueSponsoringMinistry}
                    onChange={event =>
                      this.onSelectChange(event, "issueSponsoringMinistry")
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="input-field-right select-field">
                  <Select
                    placeholder="-Select District/Department-"
                    options={this.onClickingDistrictDropDown()}
                    value={issueDistrict}
                    onChange={event =>
                      this.onSelectChange(event, "issueDistrict")
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-4">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Issues Categories-"
                    options={this.onClickingIssueCategoryDropDown()}
                    value={issueCategory}
                    onChange={event =>
                      this.onSelectChange(event, "issueCategory")
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="input-field-right select-field">
                  <Select
                    placeholder="-Select Issues Sub-categories-"
                    options={this.onClickingIssueSubCategoryDropDown()}
                    value={issueSubCategory}
                    onChange={event =>
                      this.onSelectChange(event, "issueSubCategory")
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    isDisabled={!issueCategory}
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-4">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Issue Status-"
                    options={this.onClickingIssueStatusDropDown()}
                    value={issueStatus}
                    onChange={event =>
                      this.onSelectChange(event, "issueStatus")
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            onClick={clearAllFilledDataInformation}
            className="btn-grey"
            style={{ marginRight: "8px" }}
          >
            Clear All
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onClickofApplyAllButton}
            className="btn-orange"
            style={{ width: "143px", marginLeft: "8px" }}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    sectorsList: state.misReducer.sectorsList,
    implementationModesList: state.misReducer.implementationModesList,
    statesListData: state.misReducer.statesList,
    schemesList: state.misReducer.schemesList,
    projectStatusList: state.misReducer.projectStatusList,
    misSponoringMinistry: state.misReducer.downloadSponoringMinistry,
    ddByParentIdsList: state.misReducer.ddByParentIdsList,
    issueCategoriesList: state.misReducer.issueCategories,
    issueSubCategoriesList: state.misReducer.issueSubCategoriesList,
    workflowStateDataForCentral:
      state.workflowReducer.workflowStateDataForCentral
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRecipientMinistryStateAction,
      fetchFlatFileReport,
      fetchIssueSubCategories
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IssueSummarySearchModal)
);
